export default __webpack_public_path__ + "static/media/data.d0a15a3a.svg";